export * from '@cipafacil/services/config/public-api';
